import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mention-items" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}

import { Editor } from '@tiptap/core';
import { onMounted, onUnmounted, defineAsyncComponent } from 'vue';
import unifiedToEmoji from '@/utilities/unifiedToEmoji';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmojiSearchList',
  props: {
    items: {},
    editor: {},
    command: {}
  },
  setup(__props: any) {

const SearchResults = defineAsyncComponent(
  () => import(/* webpackChunkName: "searchResults" */ '@/components/elements/SearchResults.vue')
);



onMounted(() => {
  __props.editor.commands.setMentionDropdownActive(true);
});

onUnmounted(() => {
  __props.editor.commands.setMentionDropdownActive(false);
});

function selectResult(result: any) {
  __props.command(unifiedToEmoji(result.unified));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SearchResults), {
      results: _ctx.items.result,
      "search-query": _ctx.items.query,
      "is-grouped": false,
      "tab-select": true,
      "manually-displayed": true,
      onSelectSearchResult: selectResult
    }, null, 8, ["results", "search-query"]),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_ctx.items.result.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.translate('noResults')), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})